import React from "react";

export const PrivacyPolicy = () => {
  const privacyHtml = `
    <div class="p-4 max-w-3xl mx-auto">
      <h1 class="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p class="mb-4">Effective Date: May 17, 2025</p>

      <p class="mb-4">
        At <strong>Dummy Stock Exchange</strong>, we value your privacy. This Privacy Policy outlines what personal information we collect and how we use it.
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <p class="mb-4">
        We only collect the following user information:
        <ul class="list-disc ml-6">
          <li>Email address</li>
          <li>Name</li>
          <li>Profile picture</li>
        </ul>
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
      <p class="mb-4">
        The information we collect is used solely to provide and personalize your experience within the Dummy Stock Exchange application. We do not share, sell, or rent your information to third parties.
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">Data Security</h2>
      <p class="mb-4">
        We take reasonable precautions to protect your personal information. However, no method of transmission over the internet is 100% secure.
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">Third-Party Services</h2>
      <p class="mb-4">
        We may use third-party authentication providers (e.g., Google) to log you into Dummy Stock Exchange. These services may collect data as per their own privacy policies.
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">Your Consent</h2>
      <p class="mb-4">
        By using Dummy Stock Exchange, you consent to the terms outlined in this Privacy Policy.
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">Changes to This Policy</h2>
      <p class="mb-4">
        We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
      </p>

      <h2 class="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p>If you have any questions about this policy, please contact us at: <a href="mailto:devansh.sampat@gmail.com" class="text-blue-600 underline">devansh.sampat@gmail.com</a></p>
    </div>
  `;

  return <div dangerouslySetInnerHTML={{ __html: privacyHtml }} />;
};
